export default __webpack_public_path__ + "static/m-lambo-c87c4fab157d3f5e8f036c8e13be296d.png";